import { render } from "./NFTs.vue?vue&type=template&id=79c3ece8"
import script from "./NFTs.vue?vue&type=script&lang=js"
export * from "./NFTs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__